(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Delegated so it covers every accordion on the page, and any rendered later by the
  // section rendering API, without holding a reference to markup that may be replaced.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-accordion-load-more]');
    if (!button) return;

    const accordion = button.closest('.accordion');
    if (!accordion) return;

    accordion.classList.remove('accordion--collapsed');
    button.remove();

    // Move focus to the first row that had been hidden, so a keyboard user carries on from
    // where the list grew rather than being dropped back at the top of the document.
    const shown = parseInt(button.dataset.accordionLoadMore, 10);
    const rows = accordion.querySelectorAll('accordion-custom');
    const revealed = Number.isFinite(shown) ? rows[shown] : null;
    revealed?.querySelector('summary')?.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
